import { Component, OnInit } from '@angular/core';
import { ReservationService } from '../../services/reservation.service';
import { FormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { AdminHotelNavbarComponent } from '../../components/admin-hotel-navbar/admin-hotel-navbar.component';
import { AdminRecepcionNavbarComponent } from '../../components/admin-recepcion-navbar/admin-recepcion-navbar.component';
import { NavbarComponent } from "../../components/navbar/navbar.component";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatMenuModule } from "@angular/material/menu";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { AuthService } from '../../services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { ReservationModalComponent } from '../../components/reservation-modal/reservation-modal.component';
import { HostingService } from '../../services/hosting.service';
import { TokenStorageService } from '../../services/token-storage.service';
import { ReservationGuestModalComponent } from '../../components/reservation-guest-modal/reservation-guest-modal.component';
import { ReservationDetailsComponent } from '../../components/reservation-modal/reservation-details/reservation-details.component';

interface Stat {
  label: string;
  icon: string;
  value: string;
  sub: string;
}

@Component({
  selector: 'app-admin-hotel-reservations',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DatePipe,
    AdminHotelNavbarComponent,
    AdminRecepcionNavbarComponent,
    NavbarComponent,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatFormFieldModule,
    MatSelectModule
  ],
  templateUrl: './admin-hotel-reservations.component.html',
  styleUrl: './admin-hotel-reservations.component.css'
})
export class AdminHotelReservationsComponent implements OnInit {
  // Datos
  reservations: any[] = [];
  reservas: any[] = []; // Array transformado para la vista
  paginatedReservas: any[] = [];
  accommodations: any[] = [];

  // Estados
  is_loading = false;
  error_msg = '';
  searchTerm = '';

  // Paginación
  current_page = 0;
  page_size = 10;
  page_size_options = [5, 10, 20, 50];
  totalItems = 0;

  // Estadísticas
  stats: Stat[] = [
    { label: 'Total Reservas', icon: 'event', value: '0', sub: '' },
    { label: 'Confirmadas', icon: 'check_circle', value: '0', sub: '' },
    { label: 'Pendientes', icon: 'schedule', value: '0', sub: '' },
    { label: 'Ingresos', icon: 'payments', value: '$0', sub: '' }
  ];

  // Exponer Math para el template
  Math = Math;

  constructor(
    private readonly reservationService: ReservationService,
    private readonly hostingService: HostingService,
    private readonly authService: AuthService,
    private readonly tokenStorage: TokenStorageService,
    private readonly dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.loadReservations();
  }

  // ===== CARGA DE DATOS =====
  async loadReservations(): Promise<void> {
    this.is_loading = true;
    this.error_msg = '';

    try {
      const token = this.tokenStorage.getAccessToken();
      const { user } = await this.authService.getUser();
      console.log(user);
      const response = await this.reservationService
        .getAllReservations({ page: this.current_page, limit: this.page_size, user_id: user?.id || '' }, token)
        .toPromise();

      console.log("API response", response);

      this.reservations = response.data || [];
      this.totalItems = response.total;
      this.transformReservationsData();
      this.updatePagination();
      this.updateStats();

    } catch (err) {
      console.error(err);
      this.error_msg = 'Error loading reservations';
    } finally {
      this.is_loading = false;
    }
  }

async openReservationDetails(reservation:any): Promise<void> {

    // TODO: Implementar modal de creación
   await this.loadAccommodations();
    const dialogRef = this.dialog.open(ReservationDetailsComponent, {
      width: '1000px',
      maxWidth: '95vw',
      disableClose: true,
      data: {
        reservation:reservation,
        //accommodations: this.accommodations
      }
    });
  }
  // ===== TRANSFORMACIÓN DE DATOS =====
  private transformReservationsData(): void {
    this.reservas = this.reservations.map(reservation => ({
      id: reservation.id || reservation._id || '',
      accommodation: reservation.accommodation,
      room: reservation.room,
      client: reservation.client,
      check_in: reservation.check_in ? new Date(reservation.check_in) : new Date(),
      check_out: reservation.check_out ? new Date(reservation.check_out) : new Date(),
      guests_detail: reservation.guests_detail,
      payment: reservation.payment,
      services: reservation.services || [],
      total: reservation.total_price || reservation.total || 0,
      status: this.mapEstado(reservation.status)
    }));
  }

  private mapEstado(status: string): 'Confirmada' | 'Pendiente' | 'Cancelada' | 'Completada' {
    const statusMap: { [key: string]: 'Confirmada' | 'Pendiente' | 'Cancelada' | 'Completada' } = {
      'confirmed': 'Confirmada',
      'confirmada': 'Confirmada',
      'pending': 'Pendiente',
      'pendiente': 'Pendiente',
      'cancelled': 'Cancelada',
      'cancelada': 'Cancelada',
      'completed': 'Completada',
      'completada': 'Completada'
    };

    return statusMap[status?.toLowerCase()] || 'Pendiente';
  }

  // ===== ACTUALIZACIÓN DE ESTADÍSTICAS =====
  private updateStats(): void {
    const total = this.reservas.length;
    const confirmadas = this.reservas.filter(r => r.status === 'Confirmada').length;
    const pendientes = this.reservas.filter(r => r.status === 'Pendiente').length;
    const totalIngresos = this.reservas
      .filter(r => r.status === 'Confirmada' || r.status === 'Completada')
      .reduce((sum, r) => sum + (r.total || 0), 0);

    this.stats[0].value = total.toString();
    this.stats[0].sub = `${total} reservas en total`;

    this.stats[1].value = confirmadas.toString();
    this.stats[1].sub = total > 0 ? `${Math.round((confirmadas / total) * 100)}% del total` : '0% del total';

    this.stats[2].value = pendientes.toString();
    this.stats[2].sub = pendientes > 0 ? 'Requieren atención' : 'Todo al día';

    this.stats[3].value = this.formatCurrency(totalIngresos);
    this.stats[3].sub = 'Ingresos totales';
  }

  // ===== BÚSQUEDA =====
  onSearch(): void {
    if (!this.searchTerm.trim()) {
      this.transformReservationsData();
      this.updatePagination();
      return;
    }

    const term = this.searchTerm.toLowerCase().trim();

    this.reservas = this.reservations
      .filter(reservation => {
        const alojamiento = (reservation.hosting?.name || reservation.alojamiento || '').toLowerCase();
        const habitacion = (reservation.room?.name || reservation.habitacion || '').toLowerCase();
        const email = (reservation.guest?.email || reservation.cliente?.email || '').toLowerCase();
        const id = (reservation.id || reservation._id || '').toLowerCase();

        return alojamiento.includes(term) ||
          habitacion.includes(term) ||
          email.includes(term) ||
          id.includes(term);
      })
      .map(reservation => ({
        id: reservation.id || reservation._id || '',
        accommodation: reservation.accommodation,
        room: reservation.room,
        client: reservation.client,
        check_in: reservation.check_in ? new Date(reservation.check_in) : new Date(),
        check_out: reservation.check_out ? new Date(reservation.check_out) : new Date(),
        guests_detail: reservation.guests_detail,
        payment: reservation.payment,
        total: reservation.total_price || reservation.total || 0,
        status: this.mapEstado(reservation.status)
      }));

    this.current_page = 0;
    this.updatePagination();
  }

  // ===== PAGINACIÓN =====
  get totalPages(): number {
    return Math.ceil(this.reservas.length / this.page_size);
  }

  updatePagination(): void {
    const startIndex = this.current_page * this.page_size;
    const endIndex = startIndex + this.page_size;
    this.paginatedReservas = this.reservas.slice(startIndex, endIndex);
  }

  onPageChange(page: number): void {
    if (page >= 0 && page < this.totalPages) {
      this.current_page = page;
      this.updatePagination();
    }
  }

  onPageSizeChange(size: number): void {
    this.page_size = size;
    this.current_page = 0;
    this.updatePagination();
  }

  async loadAccommodations(): Promise<void> {
    //this.accommodations = await this.hostingService.getHostingsByAdminIds();

    interface UserTokenData {
      sub?: string;
      'cognito:username'?: string;
      'cognito:groups'?: string;
      given_name?: string;
      family_name?: string;
      email?: string;
      email_verified?: boolean;
      [key: string]: any;
    }
    let user:UserTokenData | null;
    user = this.authService.getUserFromToken();

    if(user?.['cognito:groups'] && user?.['cognito:groups'].includes('admin-hotel')){
    console.log("USEEEEEEEEEEEER",user?.['cognito:groups']);
    this.accommodations = await this.hostingService.getHostingsByAdminIds();
    }

    if(user?.['cognito:groups'] && user?.['cognito:groups'].includes('admin-recepcion')){
    console.log("USEEEEEEEEEEEER",user?.['cognito:groups']);
    this.accommodations = await this.hostingService.getAllHostingIdRecepcion();
    }
  }

  formatDate(date: Date): string {
    return date.toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'UTC' // Fuerza a usar UTC
    });
  }

  // ===== ACCIONES DE RESERVA =====
  async openCreateModal(): Promise<void> {
    // TODO: Implementar modal de creación
    await this.loadAccommodations();
    const dialogRef = this.dialog.open(ReservationModalComponent, {
      width: '1000px',
      maxWidth: '95vw',
      disableClose: true,
      data: {
        accommodations: this.accommodations
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        console.log('Reserva creada:', result);
        const accessToken = this.tokenStorage.getAccessToken();
        if (!accessToken) {
          this.error_msg = 'No se encontró el token de acceso. Por favor, inicie sesión nuevamente.';
          this.is_loading = false;
          return;
        }
        //Asignamos el user_id quien fue el que realizo la reserva
        console.log(this.tokenStorage.getUser());
        result.user_id = this.tokenStorage.getUser().id;
        // TODO: Aquí llamas a tu servicio para guardar la reserva
       this.reservationService.createReservation(result, '')
  .subscribe({
    next: (response: any) => {
      // Por si API Gateway manda el error como success
      if (response?.message) {
        alert(response.message);
        return;
      }

      alert('✅ Reserva creada correctamente');
      this.loadReservations();
    },

    error: (err) => {
      console.error('❌ Error al crear la reserva:', err);

      // 🎯 MANEJO EXPLÍCITO DEL 409
      if (err.status === 409) {
        let message = 'La habitación no está disponible';

        if (err.error?.message) {
          message = err.error.message;
        } else if (typeof err.error === 'string') {
          try {
            const parsed = JSON.parse(err.error);
            message = parsed.message || message;
          } catch {
            message = err.error;
          }
        }

        alert(message);
        return;
      }

      // Otros errores
      alert('Error al crear la reserva');
    }
  });

      }
    });
  }

  viewReserva(reserva: any): void {
    console.log('Ver detalles de reserva:', reserva);
    // TODO: Implementar modal de detalles
  }

  async editReserva(reserva: any): Promise<void> {
    // TODO: Implementar modal de edición
    await this.loadAccommodations();
    const dialogRef = this.dialog.open(ReservationModalComponent, {
      width: '1000px',
      maxWidth: '95vw',
      disableClose: true,
      data: {
        accommodations: this.accommodations,
        reservation: reserva
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const accessToken = this.tokenStorage.getAccessToken();
        if (!accessToken) {
          this.error_msg = 'No se encontró el token de acceso. Por favor, inicie sesión nuevamente.';
          this.is_loading = false;
          return;
        }
        // TODO: Aquí llamas a tu servicio para actualizar la reserva
        this.reservationService.updateReservation(result, accessToken, result.id)
          .subscribe({
            next: (response: any) => {
              if (response) {
                this.loadReservations();
              }
            },
            error: (err: any) => {
              console.error('Error al editar la reserva:', err);
            }
          });
      }
    });
  }

  async deleteReserva(reserva: any): Promise<void> {
    console.log('DELETING')
    if (!confirm(`¿Estás COMPLETAMENTE seguro de ELIMINAR la reserva ? Esta acción no se puede deshacer.`)) {
      return;
    }
    try {
      this.is_loading = true;
      const token = this.tokenStorage.getAccessToken();
      if (!token) {
        this.error_msg = 'No se encontró el token de acceso. Por favor, inicie sesión nuevamente.';
        this.is_loading = false;
        return;
      }
      await this.reservationService.deleteReservation(reserva.id, token).toPromise();
      await this.authService.refreshToken().catch(() => { });

      alert('Reserva eliminada exitosamente');
      await this.loadReservations();

    } catch (err: any) {
      this.error_msg = 'Error al eliminar la reserva';
      console.error('Error deleting reservation:', err);
      alert('Error al eliminar la reserva: ' + (err?.message || 'Error desconocido'));
    } finally {
      this.is_loading = false;
    }
  }

  // ===== CREAR RESERVA =====
  async createReservation(reservationData: any): Promise<void> {
    try {
      this.is_loading = true;
      this.reservationService.createReservation(reservationData, '').subscribe({
        next: async (resp) => {
          if (resp && resp.id) {
            try {
              console.log(resp);
              alert('¡Reserva creada exitosamente!');
              await this.loadReservations();

            } catch (e: any) {
              alert('La reserva fue creada, pero no se pudo asignar al usuario: ' + (e?.message || e));
              await this.loadReservations();
            }
          }
        },
        error: (err) => {
          this.error_msg = 'Error al crear reserva';
          console.error('Error creating reservation:', err);
          alert('Error al crear reserva: ' + (err?.message || 'Error desconocido'));
          this.is_loading = false;
        },
        complete: () => {
          this.is_loading = false;
        }
      });

    } catch (err: any) {
      this.error_msg = 'Error al crear reserva';
      console.error('Error creating reservation:', err);
      alert('Error al crear reserva: ' + (err?.message || 'Error desconocido'));
      this.is_loading = false;
    }
  }

  // ===== MÉTODOS AUXILIARES =====
  formatCurrency(amount: number): string {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  }

  viewGuests(guestDetail: any): void {
    console.log("guestDetail", guestDetail);
    const guests = guestDetail.map((g: any) => ({
      fullName: `${g.given_name || g.givenName} ${g.family_name || g.familyName}`,
      documentType: g.document_type,
      documentNumber: g.document_number,
      email: g.email,
      phone: g.phone
    }));

    console.log("guests", guests);
    this.dialog.open(ReservationGuestModalComponent, {
      width: '800px',
      maxWidth: '95vw',
      disableClose: true,
      data: guests
    });
  }

  editReservation(reservation: any): void {
    this.editReserva(reservation);
  }

  deleteReservation(reservation: any): void {
    this.deleteReserva(reservation);
  }

}
